import React, { Component } from 'react';
import {
  Button, Col, Row
} from 'reactstrap';
import { withRouter} from 'react-router-dom';
import { Loading } from './LoadingComponent';
import './BestDeals.css';
import './HomeSections.css';
import ShopByMake from './../containers/ShopByMakeContainer';
import HowItWorks from "./HowItWorks";
import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'reactstrap';
import LazyLoad from 'react-lazyload';
import { accorladesData } from "../shared/promo_landing_data"
import AccoladesPromoElements from "./AccoladesPromoElements";
import fb from "../assets/single-elements/icons8-facebook-144.png"
import Typography from "@mui/material/Typography";


class BestDeals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image1: '',
      image2: '',
      image3: '',
      image4: '',
      isLoading: true,
      errMess: null,
      dealers: [],
      recommended: [],
      parts: [],
      selectedPriceTab: 1,
      selectedSearchedCarTab: 1,
      articleList: []
    };
  }

  componentDidMount() {
    this.props.getPromotionalApiData && this.props.getPromotionalApiData();
    this.props.getArticlesData && this.props.getArticlesData();

    if (this.props && this.props.location.state && this.props.location.state.pathname && this.props.location.state.pathname === "/login") {
      document.body.scrollTop = 0
      window.scrollTo(0,0);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let { getArticlesDataLoader, getArticlesDataSuccess, getArticlesDataError} = this.props
    if (getArticlesDataSuccess && prevProps.getArticlesDataSuccess !== getArticlesDataSuccess) {
      this.setState({
        articleList: getArticlesDataSuccess.articles
      })
    }
  }

  scrollToRegEntry = () => {
    const target = document.getElementById("enter-reg");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }


  render() {
    let {
      getPromotionalApiDataSuccess,
      getPromotionalApiDataError,
      getPromotionalApiDataLoader,
      getArticlesDataLoader,
      getArticlesDataSuccess,
      getArticlesDataError

    } = this.props;

    let { selectedPriceTab, selectedSearchedCarTab, articleList } = this.state;
    let trustedCars = [];
    let mostSearched = [];
    let commercialVehicles = [];

    if (getPromotionalApiDataSuccess) {
      const {
        trusted_cars,
        most_searched,
        commercial_vehicles,
      } = getPromotionalApiDataSuccess;

      if (selectedPriceTab === 0) {
        trustedCars = trusted_cars.low_range;
      } else if (selectedPriceTab === 1) {
        trustedCars = trusted_cars.mid_range;
      } else if (selectedPriceTab === 2) {
        trustedCars = trusted_cars.upper_range;
      }

      if (selectedSearchedCarTab === 0) {
        mostSearched = most_searched.hatch_back;
      } else if (selectedSearchedCarTab === 1) {
        mostSearched = most_searched.sedan;
      } else if (selectedSearchedCarTab === 2) {
        mostSearched = most_searched.suv;
      }
    }


      return (
        <div className="dealer">
          {/* Best Deals Start */}
          <section className="rc-section">
            <div className="rc-section-head">
              <h2>Know the car before you buy it</h2>
              <p>
                Outstanding finance, an insurance write-off or a stolen plate
                will not show up on a test drive. Start with a free check.
              </p>
            </div>
            <div className="container">
              <div className="row align-items-stretch">
                {accorladesData && accorladesData.map((d, i) => {
                   return (
                     <AccoladesPromoElements d={d} i={i} key={i} />
                   );
                 })}
              </div>
            </div>
          </section>
          <div>
            {/*<LazyLoad height={200} offset={100} once >*/}
              <HowItWorks />
            {/*</LazyLoad>*/}
          </div>

          {/* Closing call to action: send people back to the reg box, not off-site */}
          <section className="rc-section rc-section--tint">
            <div className="container">
              <div className="rc-closing">
                <h2>Check a reg now</h2>
                <p>Free MOT and tax report in seconds. No account needed.</p>
                <button
                  type="button"
                  className="rc-cta"
                  onClick={this.scrollToRegEntry}
                >
                  Enter a registration
                </button>
              </div>
              <div className="rc-social">
                <a
                  href="https://www.facebook.com/profile.php?id=61560652137850"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Reg Check Mate on Facebook"
                >
                  <img src={fb} alt="Facebook" />
                </a>
              </div>
            </div>
          </section>


          {/* Research & Blog Start */}
          <div
            id="auto-parts"
            className="best-deal mt-4"
            style={{
              backgroundColor: 'white',
              height: 'auto',
              paddingBottom: '64px',
              display: 'None'
            }}
          >
            <div className="col-lg-6 col-sm-12 offset-lg-3">
              <div className="headings-div-successful" style={{ textAlign: 'center' }}>
                <h3 className="headings">News and Reviews</h3>
              </div>
            </div>
            <div className="container">
                { getArticlesDataLoader ?
                  <Col sm={12}>
                    <Loading />
                  </Col>
                  :
                  <div>
                    <div className="row">
                      {articleList && articleList.map((d, i) => {
                        return (
                          <Col sm={6}>
                            <ListGroup style={{margin: "15px"}}>
                              <ListGroupItem tag="a" href={`/latest/${d.slug}/${d.id}`}>
                                <ListGroupItemHeading style={{fontWeight: 700}}> {d.date_created}</ListGroupItemHeading>
                                <ListGroupItemText>
                                  {d.title}
                                </ListGroupItemText>
                              </ListGroupItem>
                            </ListGroup>
                          </Col>
                        );
                      })}
                    </div>
                  </div>
                }
              <div className="col-lg-3 col-lg-3 col-sm-6 col-xs-6 ">
              </div>
            </div>
          </div>
          {/* Research & Blog */}

        </div>
      );
  }
}

export default withRouter(BestDeals);
